import type { Dayjs } from "dayjs";
import { useCallback, useState } from "react";
import { Severity } from "type";
import dayjs from "dayjs";
import type { SMSParams, SystemUsageParams } from "../types";
import downloadSMSApi from "../api/downloadSMSApi";
import { INVALID_DATE } from "../constants";

/**
 * Custom hooks to use system usage as CSV.
 * @param showAlert アラート表示
 */
export default function useSMSDownload(showAlert: (msg: string, severity?: Severity) => void) {
  const [targetDate, setTargetDate] = useState<Dayjs | null>(dayjs().startOf("month"));
  // const [dateFrom, setDateFrom] = useState<Dayjs | null>(null);
  // const [dateTo, setDateTo] = useState<Dayjs | null>(null);
  const [storeCd, setStoreCd] = useState<string>("");

  // const [storeName, setStoreName] = useState("");
  // const [startDate, setStartDate] = useState<Dayjs | null>(null);
  // const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDownload = useCallback(async () => {
    if (!targetDate) {
      showAlert("レポートの期間（年月）を選択してください", "error");
      return;
    }
    if (targetDate.format("YYYY-MM") === INVALID_DATE) {
      showAlert("レポートの期間（年月）を正しく選択してください", "error");
      return;
    }

    setIsLoading(true);
    try {
      // const safeTarget = target ?? 1;
      const params: SMSParams = {
        targetDate: targetDate.format("YYYY-MM"),
        storeCd,
      };
      await downloadSMSApi(params, showAlert);

      // const blob = await downloadSystemUsageApi(params);
      // const url = window.URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = `system-usage_${params.startDate}_${params.endDate}.csv`;
      // a.click();
      // window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      showAlert("CSVのダウンロードに失敗しました", "error");
    } finally {
      setIsLoading(false);
    }
  }, [targetDate, storeCd]);

  return {
    // storeName,
    // setStoreName,
    // startDate,
    // setStartDate,
    // endDate,
    // setEndDate,
    // handleDownload,
    // isLoading,

    targetDate,
    setTargetDate,
    storeCd,
    setStoreCd,
    handleDownload,
    isLoading,
  };
}
